//
//
//
//
//
//
//
//
//
//
//
//
//

    import tMenu from 'components/tMenu'
    import { domain } from 'teld-web-component/lib/env'

    export default {
        name: "t-nav",
        data() {
            return {
                theme1: 'dark',
                userInfo: null
            }
        },
        components: {
            tMenu
        },
        methods: {
            goHome() {
                this.$router.push({path: '/'})
            },
            goTeldHome() {
                window.location.href = `//www${domain}`
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/tHeader.vue